import { Badge, Button, Spinner, Modal } from "react-bootstrap";
import CourseStgType from "../../components/CourseStgType";
import { useContext, useState } from "react";
import { UserContext } from "../../userContext";
import { useTranslation } from "react-i18next";
import { resolveTemplateSyncError, joinTeamAsOwner } from "../../services/api";

export default function CourseListItem(props: any) {
  const { t, i18n } = useTranslation("common");
  const {
    course,
    setCurrentCourse,
    handleShow,
    handleCreateTeam,
    handleReloadCourses,
    getTeamSyncStatus,
  } = props;
  const user = useContext(UserContext);
  const [joiningTeam, setJoiningTeam] = useState(false);
  const [showJoinModal, setShowJoinModal] = useState(false);
  const fhsysTeachers = course.fhsysTeachers.map((teacher: any, i: any) => {
    return (
      <div key={course.id + "_" + teacher.id}>
        <strong>{teacher.name}</strong>
      </div>
    );
  });
  const fhsysCoTeachers = course.fhsysCoTeachers.map((teacher: any, i: any) => {
    return <div key={course.id + "_" + teacher.id}>{teacher.name}</div>;
  });
  const courseInstructorRow = () => {
    if (user?.departments.length || user?.fachbereiche.length) {
      return (
        <td>
          {fhsysTeachers}
          {fhsysCoTeachers}
        </td>
      );
    }
    return <></>;
  };

  const handleTemplateSyncErrorResolved = async (course: any) => {
    const formData = new FormData();
    formData.append("fhsysCourseId", course.id);
    await resolveTemplateSyncError(formData);
    handleReloadCourses();
  };

  const handleJoinTeamClick = () => {
    setShowJoinModal(true);
  };

  const handleConfirmJoinTeam = async () => {
    if (!course.teamsId) return;
    try {
      setJoiningTeam(true);
      const result = await joinTeamAsOwner(course.teamsId);
      if (result.success) {
        alert('Erfolgreich dem Team als Owner beigetreten!');
        setShowJoinModal(false);
      } else {
        alert('Fehler beim Beitreten: ' + (result.error || 'Unbekannter Fehler'));
      }
    } catch (error: any) {
      alert('Fehler beim Beitreten: ' + (error?.response?.data?.detail || error?.response?.data?.error || error.message));
    } finally {
      setJoiningTeam(false);
    }
  };

  const getTeamName = () => {
    return `COURSE-${course.wsSs}${course.year.substring(2)}-${course.titleGerman} (${course.stg} ${course.id})`;
  };

  const userAllowedToResolve = user?.role == "admin" || user?.originalRole == "admin";
  const isAdmin = user?.role === "admin" || user?.teamsRole?.includes("admin");

  return (
    <tr>
      <td>{course.departmentGerman}</td>
      <td>{course.stg}</td>
      <td>{course.fachbereichGerman}</td>
      <td>
        {course.wsSs} {course.year}
      </td>
      {courseInstructorRow()}
      <td>
        {course.moodleCourseStatus === "accepted" && course.moodleId ? (
          <a
            href={`${process.env.REACT_APP_MOODLE_BASE_URL}/course/view.php?id=${course.moodleId}`}
            target="_blank"
            rel="noopener noreferrer"
            className="link-primary"
          >
            {course.id}
          </a>
        ) : (
          course.id
        )}
      </td>
      <td>{course.titleGerman}</td>
      <td>{course.lvaType}</td>
      <td>
        {course.moodleCourseStatus == "not_requested" && (
          <a
            href="#"
            className="link-primary"
            onClick={(e) => {
              e.preventDefault();
              setCurrentCourse(course);
              handleShow();
            }}
          >
            {t("courseList.requestMoodleCourse")}
          </a>
        )}
        {course.moodleCourseStatus == "requested" && (
          <Badge bg="warning">{t("moodleCourseStatus.inProgress")}</Badge>
        )}
        {course.moodleCourseStatus == "accepted" && (
          <Badge bg="success">{t("moodleCourseStatus.created")}</Badge>
        )}
        {course.moodleCourseStatus == "rejected" && (
          <Badge bg="dark">{t("moodleCourseStatus.rejected")}</Badge>
        )}
        {course.moodleCourseStatus == "waitingForTemplateSync" && (
          <Badge bg="info">{t("moodleCourseStatus.importInProgress")}</Badge>
        )}
        {course.moodleCourseStatus == "templateSyncError" && (
          <>
            <Badge bg="danger">{t("moodleCourseStatus.importError")}</Badge>
            {userAllowedToResolve && (
              <div className="mt-2">
                <a
                  href="#"
                  onClick={(event: any) => {
                    event.preventDefault();
                    handleTemplateSyncErrorResolved(course);
                  }}
                >
                  {t("errorResolved")}
                </a>
              </div>
            )}
          </>
        )}
      </td>
      <td>
        {course.teamsCourseStatus == "not_requested" && (
          <a
            href="#"
            className="link-primary"
            onClick={() => {
              handleCreateTeam(course);
            }}
          >
            {t("courseList.requestTeamsCourse")}
          </a>
        )}
        {course.teamsCourseStatus == "requested" && (
          <Badge bg="warning">{t("teamsCourseStatus.inProgress")}</Badge>
        )}
        {course.teamsCourseStatus == "accepted" && (
          <>
            <Badge bg="success">{t("teamsCourseStatus.created")}</Badge>
            {getTeamSyncStatus && course.teamsId && (() => {
              // Jetzt nutzen wir die teamsId statt den Team-Namen zu generieren!
              const { mainStatus, errorStatus } = getTeamSyncStatus(course.teamsId);

              return (
                <div className="mt-1 d-flex gap-1 flex-wrap">
                  <Badge
                    bg={mainStatus.variant}
                    title={mainStatus.details || undefined}
                    style={{ cursor: mainStatus.details ? 'help' : 'default', fontSize: '0.85em' }}
                  >
                    {mainStatus.status}
                  </Badge>
                  {errorStatus && (
                    <Badge
                      bg={errorStatus.variant}
                      title={errorStatus.details}
                      style={{ cursor: 'help', fontSize: '0.85em' }}
                    >
                      {errorStatus.status}
                    </Badge>
                  )}
                </div>
              );
            })()}
            {isAdmin && course.teamsId && (
              <div className="mt-1">
                <Button
                  variant="primary"
                  size="sm"
                  onClick={handleJoinTeamClick}
                  disabled={joiningTeam}
                  style={{ fontSize: '0.75rem', padding: '0.25rem 0.5rem' }}
                >
                  Beitreten
                </Button>
              </div>
            )}
          </>
        )}
      </td>

      {/* Join Team Modal */}
      <Modal show={showJoinModal} onHide={() => setShowJoinModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Team beitreten</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Möchten Sie dem folgenden Team als Owner beitreten?</p>
          <div className="bg-light p-3 rounded mt-3">
            <strong>Benutzer:</strong>
            <div className="mb-2">{user?.firstname} {user?.lastname} ({user?.username})</div>

            <strong>Team:</strong>
            <div className="mb-2">{getTeamName()}</div>

            <strong>Team ID:</strong>
            <div className="mb-2"><code>{course.teamsId}</code></div>

            <strong>Kurs:</strong>
            <div className="mb-2">{course.titleGerman}</div>

            <strong>Semester:</strong>
            <div className="mb-2">{course.wsSs} {course.year}</div>

            <strong>Studiengang:</strong>
            <div>{course.stg}</div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowJoinModal(false)}
            disabled={joiningTeam}
          >
            Abbrechen
          </Button>
          <Button
            variant="primary"
            onClick={handleConfirmJoinTeam}
            disabled={joiningTeam}
          >
            {joiningTeam ? (
              <>
                <Spinner animation="border" size="sm" className="me-2" />
                Beitreten...
              </>
            ) : (
              'Beitreten'
            )}
          </Button>
        </Modal.Footer>
      </Modal>
    </tr>
  );
}
